import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { _ScheduledDiscount } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectScheduleDiscountsQuConstants = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_ScheduledDiscount);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.Value === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.Value,
                    label: found.DataBeanProperties.Property,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        instance.getScheduleDiscountsQuConstants(null).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    setLista(resp);
                }
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.Value,
        label: item.DataBeanProperties.Property,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Formato de Planilla"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Formato de Planilla..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
